import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Pendulum',
  date: new Date(2023, 8, 10),
  img: '/img/grandma.jpeg',
  tracks: [
    {
      title: 'All or Nothing',
      src: '/songs/2023-09-10/all_or_nothing.mp3',
    },
    {
      title: 'The Push and The Pull',
      src: '/songs/2023-09-10/the_push_and_the_pull.mp3',
    },
    {
      title: 'Out of the Darkness',
      src: '/songs/2023-09-10/out_of_the_darkness.mp3',
    },
    {
      title: 'Won\'t you come and play with us?',
      src: '/songs/2023-09-10/wont_you_come_and_play_with_us.mp3',
    },
    {
      title: 'Gotham\'s Seedy Underbelly',
      src: '/songs/2023-09-10/gothams_seedy_underbelly.mp3',
    },
    {
      title: 'Weaning Grandma of the Pipe',
      src: '/songs/2023-09-10/weaning_grandma_off_the_pipe.mp3',
    },
    {
      title: 'It\'s so much better in here',
      src: '/songs/2023-09-10/its_so_much_better_in_here.mp3',
    },
    {
      title: 'Special Cup',
      src: '/songs/2023-09-10/special_cup.mp3',
    },
    {
      title: 'Of Hooves & Wings',
      src: '/songs/2023-09-10/of_hooves_and_wings.mp3',
    },
    {
      title: 'Always Love, Always Truth',
      src: '/songs/2023-09-10/always_love_always_truth.mp3',
    },
    {
      title: '1, 2, 3 - Hit it!',
      src: '/songs/2023-09-10/one_two_three_hit_it.mp3',
    },
  ]
}
export default album;